// Display dates/times in Asia/Kuala_Lumpur as DD/MM/YYYY, HH:mm:ss
const TZ = 'Asia/Kuala_Lumpur';

function pad(n) { return String(n).padStart(2, '0'); }

function partsKL(date) {
  const fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  });
  const obj = Object.fromEntries(fmt.formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, p.value]));
  return obj;
}

export function formatKL(iso) {
  if (!iso) return '';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return '';
  const p = partsKL(d);
  return `${p.day}/${p.month}/${p.year}, ${p.hour}:${p.minute}:${p.second}`;
}

export function formatKLDate(iso) {
  if (!iso) return '';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return '';
  const p = partsKL(d);
  return `${p.day}/${p.month}/${p.year}`;
}

export function formatKLShort(iso) {
  if (!iso) return '';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return '';
  const p = partsKL(d);
  return `${p.day}/${p.month}, ${p.hour}:${p.minute}`;
}
